<template>
  <div
    id="app"
    class="bg-[#FF9500] w-full mx-auto"
    :class="
      currentPath === '/admin/airport/toulouse/blagnac/agency/checkcode/control'
        ? 'max-w-none'
        : 'max-w-2xl'
    "
  >
    <HeaderView />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <FooterView />
  </div>
</template>
<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";
export default {
  name: "header-view",
  components: {
    HeaderView,
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
   this.loadUmamiScript("8edc9414-936a-4366-9dda-e07cc9d66b48") 
  },
  methods: {
    loadUmamiScript(websiteId) {
      console.log(websiteId, "websiteId");
      const scriptElement = document.createElement("script");
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.src = "https://eu.umami.is/script.js";
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style>
/* Transition fade in/fade out */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
